/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruleremove2Inputs */

const en_dropruleremove2 = /** @type {(inputs: Dropruleremove2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove rule`)
};

const de_dropruleremove2 = /** @type {(inputs: Dropruleremove2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regel entfernen`)
};

/**
* | output |
* | --- |
* | "Remove rule" |
*
* @param {Dropruleremove2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruleremove2 = /** @type {((inputs?: Dropruleremove2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruleremove2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruleremove2(inputs)
	return de_dropruleremove2(inputs)
});
export { dropruleremove2 as "dropRuleRemove" }